import { ScrollArea, Skeleton } from '@mantine/core';
import ArrowRight from 'components/DynamicIcon/ArrowRight';
import CategoryGift from 'components/Molecules/LoyaltyStore/CategoryGift';
import MyGiftModal from 'components/Molecules/LoyaltyStore/MyGiftModal';
import {
  getListMenuCategoryAction,
  getListMyGiftUnusedOwnAction,
  getListMyGiftUsedOwnAction,
} from 'model/actions/LoyaltyGiftAction';
import { getListGiftWithType } from 'model/services/LoyaltyGiftService';
import { defaultIcon } from 'pages/DetailGiftCategory';
import React, { memo, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { convertObjToArr } from 'utils';
import QueryString from 'qs';
import useDevice from 'hooks/useDevice';

// import giftCategory from './data';

const Gift = ({ loyaltyData }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { isDesktop } = useDevice();

  // @ts-ignore
  const listMenuGift = useSelector((state) => state.LoyaltyGiftReducer.listMenu);
  const myOwnGift = useSelector((state) => state.LoyaltyGiftReducer.myOwnGift);
  // @ts-ignore
  const listHotGift = useSelector((state) => state.LoyaltyAccountInfoReducer.listGroupGift);
  const [listGiftCategory, setListGiftCategory] = useState([]);
  const [myGift, setMyGift] = useState({ myGift: [], used: [] });
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingGift, setIsLoadingGift] = useState(true);
  const [isOpenMyGiftModal, setIsOpenMyGiftModal] = useState(false);
  const divRef = useRef(null);

  localStorage.setItem('hottest', JSON.stringify(listHotGift));

  const scrollToEnd = () => {
    divRef.current.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center',
    });
  };
  const getDataGiftCb = (id) => {
    setIsLoading(true);
    const payload = {
      memberCode: loyaltyData.obj.code,
      levelFilter: 2,
      parentGiftCategoryCode: '',
      maxGiftCategoryItem: null,
      giftCategorySorting: '',
      maxGiftInforItem: null,
      giftInforSorting: '',
      categoryGame: null,
    };
    return getListGiftWithType(payload).then((res) => {
      let result = [];
      res.obj.forEach((item) => {
        result.push({
          giftList: item.giftInfors || [],
          giftCategory: item.giftCategory,
          name: item.giftCategory.name || 'Mới nhất',
          code: item.giftCategory.code,
          show: item.giftInfors.length > 0,
        });
      });
      setListGiftCategory(result);
      setIsLoading(false);
    });
  };
  const handleUpdateInfoGiftCategory = (info) => {
    localStorage.setItem(
      'typeGift',
      JSON.stringify({
        title: info.title || 'Quà tặng',
        icon: info.icon || defaultIcon,
      })
    );
  };
  const getGiftVoucher = async (memberCode) => {
    setIsLoadingGift(true);
    dispatch(getListMyGiftUsedOwnAction({ memberCodeFilter: memberCode, selectTab: 2 }));
    dispatch(getListMyGiftUnusedOwnAction({ memberCodeFilter: memberCode, selectTab: 1 }));
  };

  useEffect(() => {
    if (loyaltyData.obj.code) {
      const memberCode = loyaltyData.obj.code;
      const listMenuArr = convertObjToArr(listMenuGift.obj);
      if (listMenuArr.length <= 0) {
        dispatch(getListMenuCategoryAction(memberCode));
      }
      getDataGiftCb();
      getGiftVoucher(memberCode);
    }
  }, [loyaltyData.obj.code]);

  useEffect(() => {
    if (myOwnGift.unused.responseStatus) {
      setMyGift({ myGift: myOwnGift.unused.obj, used: myOwnGift.used.obj });
      setIsLoadingGift(false);
    }
  }, [myOwnGift]);

  useEffect(() => {
    if (location.hash.includes('#openGift=true')) {
      let a = QueryString.parse(location.hash);
      delete a['#openGift'];

      if (loyaltyData.obj.code) {
        const memberCode = loyaltyData.obj.code;
        getGiftVoucher(memberCode);
      }
      setIsOpenMyGiftModal(true);
      navigate(`#openGift=false${QueryString.stringify(a) ? '&' + QueryString.stringify(a) : ''}`);
    }
  }, [location]);

  return (
    <div className='pt-10px lg:p-0'>
      <div className='mb-4 rounded-lg bg-white'>
        <div onClick={() => !isLoadingGift && setIsOpenMyGiftModal(true)}>
          <div className='flex justify-between border-b px-6 py-3 font-averta-bold text-18px'>
            <div className='flex'>
              <div className='flex cursor-pointer text-black'>
                <p>Quà của tôi: &nbsp;</p>
                {!isLoadingGift ? (
                  myGift.myGift?.length + myGift.used?.length
                ) : (
                  <Skeleton className='flex' width={18} height={27} ml={4} />
                )}
              </div>
              <p className='mx-2 w-px bg-D9D9D9'></p>
              <div className='flex cursor-pointer text-008BD2'>
                <p>Chưa sử dụng: &nbsp;</p>
                {!isLoadingGift ? (
                  myGift.myGift?.length
                ) : (
                  <span className='inline h-5 w-5'>
                    <Skeleton className='flex' width={18} height={27} ml={4} />
                  </span>
                )}
              </div>
            </div>
            <ArrowRight fill={'#000'} />
          </div>
        </div>
        {listGiftCategory.length > 0 ? (
          <div className='relative'>
            {isDesktop ? (
              <div className='flex overflow-x-scroll pb-[20px] pr-[50px]'>
                <div
                  onClick={() => scrollToEnd()}
                  className='absolute right-20px top-40px flex h-40px w-40px cursor-pointer items-center justify-center rounded-full bg-[#008fd3]'
                >
                  <ArrowRight size={35} fill={'#ffffff'} />
                </div>
                {listGiftCategory.map((section, index) => {
                  return (
                    <Link
                      ref={index === listGiftCategory.length - 1 ? divRef : null}
                      className='block w-min flex-grow-0'
                      to={`/pages/loyalty-store/detail?code=${section.giftCategory.code}`}
                      key={index}
                      onClick={() =>
                        handleUpdateInfoGiftCategory({
                          title: section.giftCategory.name || 'Quà tặng',
                          icon: section.giftCategory.imageLink.fullLink || defaultIcon,
                        })
                      }
                    >
                      <div className='flex h-[104px] w-[100px] min-w-[100px] max-w-[100px] flex-col justify-items-end p-2'>
                        <img
                          className='mx-auto my-2'
                          style={{ height: '35px' }}
                          src={
                            section.giftCategory.imageLink.fullLink || ''
                            // '/assets/images/loyalty/pc/gift/utility.png'
                          }
                          alt=''
                        />
                        <p className='text-center text-16px'>{section.giftCategory.name}</p>
                      </div>
                    </Link>
                  );
                })}
              </div>
            ) : (
              <ScrollArea style={{ width: '100%', overflowX: 'auto' }}>
                <div className='flex h-[210px] w-fit flex-col flex-wrap items-start justify-start'>
                  {listGiftCategory.map((section, index) => {
                    return (
                      <Link
                        className='block w-min flex-grow-0'
                        to={`/pages/loyalty-store/detail?code=${section.giftCategory.code}`}
                        key={index}
                        onClick={() =>
                          handleUpdateInfoGiftCategory({
                            title: section.giftCategory.name || 'Quà tặng',
                            icon: section.giftCategory.imageLink.fullLink || defaultIcon,
                          })
                        }
                      >
                        <div
                          className='flex h-[104px] w-[100px] min-w-[100px] max-w-[100px] flex-col justify-items-end p-2'
                          // style={{ width: '90px', flexGrow: '1' }}
                        >
                          <img
                            className='mx-auto my-2'
                            style={{ height: '30px' }}
                            src={
                              section.giftCategory.imageLink.fullLink || ''
                              // '/assets/images/loyalty/pc/gift/utility.png'
                            }
                            alt=''
                          />
                          <p className='text-center text-14px'>{section.giftCategory.name}</p>
                        </div>
                      </Link>
                    );
                  })}
                </div>
              </ScrollArea>
            )}
          </div>
        ) : (
          <div className='w-full'>
            <div className='p-5'>
              <Skeleton width={35} height={35} />
              <Skeleton width={35} height={14} mt={8} />
            </div>
            <div className='p-5 pt-0'>
              <Skeleton width={35} height={35} />
              <Skeleton width={35} height={14} mt={8} />
            </div>
          </div>
        )}
      </div>
      <CategoryGift
        code={`${convertObjToArr(listHotGift.obj).length > 0 ? 'hottest' : ''}`}
        listGift={listHotGift.obj}
        info={{ title: 'Hot nhất', icon: defaultIcon }}
      />
      {listGiftCategory.length > 0 ? (
        listGiftCategory.map((section, index) => {
          return (
            section.show && (
              <CategoryGift
                key={index}
                listGift={section.giftList}
                code={section.code}
                info={{
                  title: section.giftCategory.name || 'Hấp dẫn',
                  icon: section.giftCategory.imageLink.fullLink || defaultIcon,
                }}
              />
            )
          );
        })
      ) : (
        <CategoryGift listGift={[]} info={{ title: 'Quà tặng', icon: defaultIcon }} />
      )}
      {isOpenMyGiftModal && (
        <MyGiftModal
          myGift={myGift}
          opened={isOpenMyGiftModal}
          handleOpened={setIsOpenMyGiftModal}
          reloadData={getDataGiftCb}
        />
      )}
    </div>
  );
};

export default memo(Gift);
